// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MonthlyVarianceReportContextConfig{
    export const MVR_LOOK_BACK_YEARS = 2;
    export const MVR_LOOK_FWD_YEARS = 1;
}
